import { Controller } from "@hotwired/stimulus"

// data-controller="student-profile-tabs"
// data-student-profile-tabs-active-value="general"
// targets: tab (each tab button), panel (each turbo-frame)
export default class extends Controller {
  static targets = ["tab", "panel"]
  static values  = { active: String }

  connect() {
    // `initial: true` — the active panel on first paint is server-rendered
    // with loading="eager", so its <turbo-frame> already started fetching
    // its own content the moment it was parsed (Turbo's native eager load
    // doesn't depend on Turbo Drive, which is off app-wide). Calling
    // ensureLoaded() here too would reassign that frame's `src` to the same
    // URL mid-flight, which Turbo treats as a reload request: it aborts the
    // in-flight fetch and starts a new one. That race is what left the
    // default "Общая информация" tab rendering empty — the only tab reached
    // via its own native eager load instead of exclusively via this
    // controller's forced ensureLoaded() (tab switches render fine because
    // their lazy frames are never auto-loaded by Turbo in the first place).
    this.activate(this.activeValue || "general", { pushState: false, initial: true })
  }

  switch(event) {
    event.preventDefault()
    const name = event.currentTarget.dataset.tabName
    this.activate(name)
  }

  activate(name, { pushState = true, initial = false } = {}) {
    this.tabTargets.forEach(t => {
      const on = t.dataset.tabName === name
      // Keep the full active look in sync — the server renders these utilities
      // on the active tab, so a client switch must add/remove all of them, not
      // just the `tab-active` hook (otherwise the old tab stays highlighted).
      t.classList.toggle("tab-active", on)
      t.classList.toggle("bg-white", on)
      t.classList.toggle("text-gray-900", on)
      t.classList.toggle("shadow-sm", on)
      t.classList.toggle("text-gray-500", !on)
      t.classList.toggle("hover:text-gray-900", !on)
    })

    this.panelTargets.forEach(p => {
      const matches = p.id === `panel-${name}`
      p.classList.toggle("hidden", !matches)
      if (matches && !initial) this.ensureLoaded(p)
    })

    if (pushState) {
      const url = new URL(window.location.href)
      url.searchParams.set("tab", name)
      history.replaceState({}, "", url.toString())
    }
  }

  ensureLoaded(frame) {
    if (frame.hasAttribute("complete")) return
    const src = frame.getAttribute("src")
    if (src) frame.src = src
  }
}
